export const OFFER_COMPONENTS_TRANSLATION_NAMESPACE = "offer-components";

export const DISPLAY_PARAMETER_TK = "DISPLAY_PARAMETER_TK";
export const HEADER_FILTERS_TK = "HEADER_FILTERS_TK";
export const SPECIFIC_ID_FILTER_HOOK_TK = "SPECIFIC_ID_FILTER_HOOK_TK";
export const REFRESH_BUTTON_TK = "REFRESH_BUTTON_TK";
